import dayjs from "dayjs";

export const initStructure = {
    id: '',
    title: '',
    document_type_id: null,

    countries_id_array: [],
    adv_res_id_array: [],
    department_id: null,
    current_roles_json: [],

    period_id: 1,
    period_type_id: 1,

    brand_id: null,
    date_start: dayjs(new Date(new Date().getFullYear(), 0, 1, 12)),
    date_end: dayjs(new Date(new Date().getFullYear(), 11, 31, 12)),
    tags_array: [],
    description: '',
    document_url: '',
    is_archived: false,
    created_at: null,
    updated_ad: null
}